export default "__VITE_ASSET__CCbrkpZ1__"